<!-- TEMPLATE -->
<template>
  <div class="dismb-container">
    <div
      :id="id"
      v-if="!hasActiveItems && !showItems" 
      class=dismb>
      <div @click="showItems = !showItems" class="dismb-header dismb-header-inactive dismb-header-no-items">
        <p>{{ label }}</p>
      </div>
    </div>
    <div
      v-if="hasActiveItems || showItems"  
      class="dismb">
      <div :class="headerClass"
        @click="showItems = !showItems">
        <p>{{ label }}</p>
      </div>
      <div class="dismb-items">
        <span
          v-for="(item, key) in tempValue"
          v-if="item.value || showItems"
          :key="String(key)"
          :class="isActive(key)"
          @click="itemClicked(key)"
        >
          <p>{{ item.label }}</p>
          <dean-icon
            v-if="item.value"
            class="dismb-item dismb-item-close"
            :glyph="closeIcon"
            width="18"
            height="18"
            >
          </dean-icon>
          <dean-icon
            v-else
            class="dismb-item dismb-item-add"
            :glyph="plusIcon"
            width="18"
            height="18"
            >
          </dean-icon>
        </span>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

// SVG
import goToIcon from '../svg/feather-icons/corner-up-right.svg';
import closeIcon from '../svg/feather-icons/x.svg';
import plusIcon from '../svg/feather-icons/plus.svg';

import deanSectionDivider from './deanSectionDivider.vue';
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanSectionDivider,
    deanIcon
  }
})

export default class deanInputSelectMultiBox extends Vue {
  // PROPS
  @Prop({
    default: () => {
      return [
        {
          id: 'monday',
          label: 'Maandag',
          value: false
        },
        {
          id: 'tuesday',
          label: 'Dinsdag',
          value: false
        },
        {
          id: 'wednesday',
          label: 'Woensdag',
          value: false
        },
        {
          id: 'thursday',
          label: 'Donderdag',
          value: false
        },
        {
          id: 'friday',
          label: 'Vrijdag',
          value: false
        },
        {
          id: 'saturday',
          label: 'Zaterdag',
          value: false
        },
        {
          id: 'sunday',
          label: 'Zondag',
          value: false
        }
      ]
    }
  })
  data!: Array<object>;

  @Prop({ default: 'deanInputSelectMultiBox' }) id!: string;
  @Prop({ default: 'opties' }) title!: string;

  // DATA
  button!: boolean;
  goToIcon: object = goToIcon;
  closeIcon: object = closeIcon;
  plusIcon: object = plusIcon;
  tempValue: Array<any> = [];
  showItems: boolean = false;


  @Watch('data') 
  dataChanged() {
    this.tempValue = this.data
    if (!this.hasActiveItems) {
      this.showItems = true;
    }
  }

  get label() {
    if (!this.hasActiveItems && !this.showItems) return 'Selecteer ' + this.title + '...'
    if (this.hasInActiveItems && !this.showItems) return 'Toon alle beschikbare ' + this.title + '...'
    if (!this.hasInActiveItems) return 'Alle ' + this.title + ' geselecteerd...'
    else return 'Seleceer '  + this.title + '...'
  }

  get headerClass() {
    if (!this.showItems) return `dismb-header dismb-header-inactive`
    if (this.showItems) return `dismb-header dismb-header-active`;
  }

  get hasActiveItems() {
    let value = false
    for (let item in this.tempValue) {
      if (this.tempValue[item].value == true) {
        value = true
      }
    }
    return value
  }

  get hasInActiveItems() {
    let value = false
    for (let item in this.tempValue) {
      if (this.tempValue[item].value == false) {
        value = true
      }
    }
    return value
  }

  isActive(key: string) {
    if (this.tempValue[key].value == true) return `active`;
  }

  itemClicked(key: string) {
    this.tempValue[key].value = !this.tempValue[key].value;
    const emitData = {
      id: this.id,
      data: this.tempValue
    }
    console.log(emitData)
    this.$emit('changed', emitData);
  }

  mounted() {
    this.dataChanged();
  }
}

</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN WIDGET
.dismb-container {
  padding: 10px;
  .dismb {
    border: 1px solid var(--color-light-shade-2, $color-light-shade-2);
    @include border-radius(10px);
    @include transition(all ease 0.8s);
    &:hover {
      outline: none;
      box-shadow: 0px 0px 10px 2px var(--color-secondary, $color-secondary);
    }
    .dismb-header {
      @include display-flex();
      position: relative;
      align-items: center;
      height: 40px;
      cursor: pointer;
      border-bottom: 1px solid var(--color-light-shade-2, $color-light-shade-2);
      p {
        padding: 10px 20px 10px 20px;
        align-self: center;
      }
      &:after {
        position: absolute;
        top: 18px;
        content: '';
        right: 10px;
        width: 0px;
        height: 0px;
        background: white;
      }
    }
    .dismb-header-inactive {
      &:after {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid var(--color-dark-shade-4, $color-dark-shade-4);
      }
    }
    .dismb-header-active {
      &:after {
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
        border-bottom: 4px solid var(--color-dark-shade-4, $color-dark-shade-4);
      }
    }
    .dismb-header-no-items {
      border: 0;
    }
    .dismb-items {
      @include display-flex();
      padding: 1%;
      -webkit-flex-wrap: wrap;
      flex-wrap: wrap;
      width: 100%;
      span {
        position: relative;
        @include display-flex();
        justify-content: space-between;
        align-items: center;
        width: 48%; 
        @media #{$medium} { width: 31.333333%; }
        padding: 10px 20px 10px 20px;
        @include border-radius(100px);
        @include transition(0.5s);
        cursor: pointer;
        text-align: center;
        margin: 1%;
        border: 1px solid var(--color-light-shade-2, $color-light-shade-2);
        word-break: keep-all;
        white-space: no-wrap;
        &:hover {
          background: var(--color-secondary, $color-secondary);
          border: 1px solid  var(--color-secondary, $color-secondary);
          color: white;

          .dismb-item-close {
            fill: var(--color-info-danger-border, $color-info-danger-border);
          }
          .dismb-item-add {
            fill: white;
          }
        }
        p { 
          padding: 0 5px 0 0;
          margin: 0;
        }
        .dismb-item {
          padding: 2px;
          min-height: 18px;
          height: 18px;
          min-width: 18px;
          width: 18px;
          cursor: pointer;
          transition: 0.5s;
        }
          
        .dismb-item-close {
          fill: var(--color-info-danger, $color-info-danger);
        }

        .dismb-item-add {
          fill: var(--color-link, $color-link);
        }

      }
      .active {
        background:  var(--color-light-shade-2, $color-light-shade-2);
        border: 1px solid  var(--color-light-shade-2, $color-light-shade-2);
        &:hover {
          background: var(--color-light, $color-light);
          color:  var(--color-info-danger, $color-info-danger);
          border: 1px solid  var(--color-light-shade-2, $color-light-shade-2);
        }
      }
    }
  }
}
</style>
